export const languageNames = {
    en: 'English',
    es: 'Español',
    'es-419': 'Español (Latinoamérica)',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    'pt-BR': 'Português (Brasil)',
    nl: 'Nederlands',
    pl: 'Polski',
    ru: 'Русский',
    uk: 'Українська',
    
    sv: 'Svenska',
    no: 'Norsk',
    da: 'Dansk',
    fi: 'Suomi',
    is: 'Íslenska',
    
    ca: 'Català',
    gl: 'Galego',
    eu: 'Euskara',
    ro: 'Română',
    hu: 'Magyar',
    cs: 'Čeština',
    sk: 'Slovenčina',
    'sk-SK': 'Slovenčina',
    sl: 'Slovenščina',
    hr: 'Hrvatski',
    sr: 'Srpski',
    bg: 'Български',
    el: 'Ελληνικά',
    tr: 'Türkçe',
    et: 'Eesti',
    lv: 'Latviešu',
    lt: 'Lietuvių',
    mt: 'Malti',
    ga: 'Gaeilge',
    cy: 'Cymraeg',
    
    af: 'Afrikaans',
    sw: 'Kiswahili',
    zu: 'isiZulu',
    xh: 'isiXhosa',
    
    zh: '中文',
    'zh-CN': '中文 (简体)',
    'zh-TW': '中文 (繁體)',
    'zh-HK': '中文 (香港)',
    ja: '日本語',
    ko: '한국어',
    th: 'ไทย',
    vi: 'Tiếng Việt',
    id: 'Bahasa Indonesia',
    ms: 'Bahasa Melayu',
    tl: 'Tagalog',
    hi: 'हिन्दी',
    bn: 'বাংলা',
    ta: 'தமிழ்',
    te: 'తెలుగు',
    mr: 'मराठी',
    ur: 'اردو',
    
    ar: 'العربية',
    'ar-SA': 'العربية (السعودية)',
    he: 'עברית',
    fa: 'فارسی',
    
    sq: 'Shqip',
    hy: 'Հայերեն',
    az: 'Azərbaycan',
    be: 'Беларуская',
    bs: 'Bosanski',
    ka: 'ქართული',
    kk: 'Қазақ',
    mk: 'Македонски',
    mn: 'Монгол',
    ne: 'नेपाली',
    pa: 'ਪੰਜਾਬੀ',
    si: 'සිංහල',
    uz: 'Oʻzbek'
};

/**
 * Get the display name for a language code
 * @param {string} langCode - ISO 639-1 language code
 * @returns {string} - Language name or the code itself if not found
 */
export function getLanguageName(langCode) {
    return languageNames[langCode] || langCode;
}

export default languageNames;
